import axios from "axios"

export const checkExist = async (user: any) => {
    try {
        const { data } = await axios.post(
            `${process.env.NEXT_PUBLIC_API_URL}users/check`,
            user
        )

        return data
    } catch (err: any) {
        return err.response.data
    }
}
